package com.essntl.features.invoice.ui.addeditinvoice

sealed interface AddEditInvoiceNavigation {
    data object AddExtraService : AddEditInvoiceNavigation
}